import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import AppContext from "../../context/AppContext";
import { getClassName } from "./functions";
import Glyphicon from "../Glyphicon";

class MenuItem extends PureComponent<any> {
  static contextType = AppContext;

  handleClick = () => {
    const { selectMenu } = this.context;
    selectMenu(this.props.menu.id);
  };

  render() {
    const { selectedMenu } = this.context;
    const { menu } = this.props;
    return (
      <span className={getClassName(menu.id, selectedMenu)}>
        <button className="MenuItem_button" onClick={this.handleClick}>
          <Glyphicon className="MenuItem_icon" icon={menu.icon} />
          {menu.label}
        </button>
      </span>
    );
  }
}

export default MenuItem;
